module.exports = __webpack_public_path__ + "static/media/congress_cover_ru.c8d834a5.png";